import React, { useEffect } from "react"

import {
	directSiteBrokerProvider,
	includeProviders,
	mainSite,
	mainSiteProvider,
	offices,
	reports,
	searchID,
	singleDate,
	sites,
	userData
} from "@signals"
import { useAnalyzerBrokersFilters } from "./@hooks"
import { brokersSchema } from "./schema"
import AnalyzerCommonFilters from "Pages/AnalyzersV2/Filters"


export default function BrokersFilters() {

	const { onSubmit, isValid, errors } = useAnalyzerBrokersFilters()

	useEffect(() => {
		singleDate.value = null
		mainSiteProvider.value = false
		includeProviders.value = userData.value?.WebProviderAnalyzerGroupDefault
		mainSite.value = ''
	}, [reports.value, offices.value, searchID.value])

	return <AnalyzerCommonFilters
		components={{
			lengthRental: !!offices.value && !!reports.value || searchID.value,
			webProviderToggle: false,
			acrissCategoryToggle: true,
			directSiteBrokerProviderToggle: true,
			mainSite: !directSiteBrokerProvider.value && !!offices.value && !!reports.value,
			mainProvider: !!directSiteBrokerProvider.value && !!offices.value && !!reports.value
		}}
		compProps={{
			mainSite: {
				filters: {
					getDirectSites: true,
				}
			},
			sites: {
				multiple: false,
				filters: {
					getDirectSites: false,
				},
				onFinishAjax: options => {
					sites.value = options[0].value
				}
			}
		}}
		onSubmit={onSubmit}
		isValid={isValid}
		errors={errors}
		schema={brokersSchema}
	/>
}